export const ANNOTATION_RESEARCH_NOTE_SCHEMA_VERSION = 'variorum.annotation-note.v1' as const

export type AnnotationResearchNoteTargetKind =
  | 'coreference'
  | 'focalization'
  | 'characterization'
  | 'speaker'
  | 'section'

export type AnnotationResearchNoteState =
  | 'observation'
  | 'question'
  | 'argument'
  | 'citation-ready'

export interface AnnotationResearchNoteTarget {
  kind: AnnotationResearchNoteTargetKind
  annotationId: string
  /** Stable identity shared by physical fragments of one logical annotation,
      currently used by multi-unit speaker turns. */
  logicalId?: string
  characterId?: string
  characterLabel?: string
  annotationLabel?: string
}

export interface AnnotationResearchNotePassageSnapshot {
  sourceWitnessId: string
  rowIds: string[]
  unitLabels: string[]
  quotedText: string
  contextText: string
  capturedAt: string
  truncated: boolean
}

export interface AnnotationResearchNote {
  id: string
  schemaVersion: typeof ANNOTATION_RESEARCH_NOTE_SCHEMA_VERSION
  chapterId: string
  bookId?: string
  sourceWitnessId: string
  target: AnnotationResearchNoteTarget
  title?: string
  bodyMarkdown: string
  researchState: AnnotationResearchNoteState
  keywords: string[]
  passageSnapshot: AnnotationResearchNotePassageSnapshot
  createdAt: string
  updatedAt: string
  archivedAt?: string
}

export interface CreateAnnotationResearchNoteInput {
  id?: string
  chapterId: string
  bookId?: string
  sourceWitnessId: string
  target: AnnotationResearchNoteTarget
  title?: string
  bodyMarkdown: string
  researchState?: AnnotationResearchNoteState
  keywords?: readonly string[]
  passageSnapshot: AnnotationResearchNotePassageSnapshot
  now?: string
}

export interface AnnotationResearchNoteMarkdownContext {
  workLabel?: string
  witnessLabel?: string
}
